import { EntityModules, MonitoringMethod, UserRole } from 'core/constants';

import SessionUser from '../../stores/Session/SessionUser';

import { ADMIN_AND_ACCOUNT_MANAGERS, ADMIN_AND_MANAGERS, MANAGERS, NON_ARC_OPERATORS } from './roleGroups';

interface AlertOwner {
  monitoringMethod: MonitoringMethod;
}

export const canHandleRedAlert = (user: SessionUser | null, alertOwner: AlertOwner | null): boolean => {
  if (!user) {
    return false;
  }
  if ([UserRole.Admin, UserRole.ArcOperator].includes(user.role)) {
    return true;
  }
  return !!(MANAGERS.includes(user.role) && alertOwner?.monitoringMethod === MonitoringMethod.SelfMonitored);
};

export const canAccessRisksProduct = (user: SessionUser | null): boolean =>
  !!user && user.activeEntityModules.includes(EntityModules.Risks) && user.risksAssessmentsModuleEnabled;

export const canAuthorRiskAssessmentTemplates = (user: SessionUser | null): boolean =>
  !!user && canAccessRisksProduct(user) && ADMIN_AND_ACCOUNT_MANAGERS.includes(user.role);

export const canAddToLibrary = (user: SessionUser | null): boolean => !!user && NON_ARC_OPERATORS.includes(user.role);

export const canEditLibrary = (user: SessionUser | null): boolean => !!user && ADMIN_AND_MANAGERS.includes(user.role);

export const canArchiveLibrary = canEditLibrary;

export const canManageLibraryCategories = (user: SessionUser | null): boolean =>
  !!user && ADMIN_AND_ACCOUNT_MANAGERS.includes(user.role);

export const canLinkRiskControls = (user: SessionUser | null): boolean =>
  !!user && ADMIN_AND_MANAGERS.includes(user.role) && !user.readOnly;
